// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import myw from 'myWorld-base';
import L from 'leaflet';

myw.UserLocationPlugin = myw.Plugin.extend({
    /**
     * @class Provides location tracking functionality <br/>
     * Adds a button to the toolbar which activates the location tracking and adds a marker to the map
     * @param  {Application} owner                       The application
     * @constructs
     * @extends {Plugin}
     */
    initialize(owner) {
        myw.Plugin.prototype.initialize.call(this, owner);

        this.ll = null;
        this.marker = null;
        this.tracking = false;
        this.watchId = null;
    },

    locate() {
        if (!navigator.geolocation) {
            $.get('html/modern-browser.htm', data => {
                $(data).dialog({
                    modal: true,
                    width: 400,
                    title: this.msg('unavailable')
                });
            });
            return;
        }

        if (this.tracking) {
            this.trackUserStop();
        } else {
            this.trackUserStart();
        }
    },

    set(latLng) {
        this.ll = latLng;
    },

    trackUserError(err) {
        console.log(`ERROR(${err.code}): ${err.message}`);
        //stop tracking
        this.trackUserStop();

        //inform user of problem
        const msgId = err.code === 1 ? 'geolocation_not_authorised' : 'geolocation_generic_error';
        this.app.message(this.app.msg(msgId));
        this.trigger('change');
    },

    trackUserStart() {
        if (navigator.geolocation) {
            this.watchId = navigator.geolocation.watchPosition(
                this.showPosition.bind(this),
                this.trackUserError.bind(this),
                {
                    enableHighAccuracy: true,
                    maximumAge: 0
                }
            );
            $('#icon-locate').attr(
                'src',
                this.app.isHandheld
                    ? 'images/phone/iphone-location-60-2-active.png'
                    : 'images/toolbar/locate-active.png'
            );
        }
    },

    trackUserStop() {
        if (navigator.geolocation) {
            this.tracking = false;

            if (this.watchId !== null) {
                navigator.geolocation.clearWatch(this.watchId);
                this.watchId = null;
            }
            if (this.ll) this.ll = null;
            if (this.marker) {
                this.app.map.removeLayer(this.marker);
                this.marker = null;
            }
            $('#icon-locate').attr(
                'src',
                this.app.isHandheld
                    ? 'images/phone/iphone-location-60-2.png'
                    : 'images/toolbar/locate.png'
            );
        }
    },

    showPosition(pos) {
        this.tracking = true;
        this.ll = new L.LatLng(pos.coords.latitude, pos.coords.longitude);

        if (!this.marker) {
            this.marker = new L.Marker(this.ll, {
                icon: new L.Icon({
                    iconUrl: 'images/markers/user-location.png',
                    iconSize: [38, 38]
                }),
                clickable: false
            }).addTo(this.app.map);
        } else {
            this.marker.setLatLng(this.ll);
            this.marker.update();
        }

        this.app.map.panTo(this.ll);
        this.trigger('change');
    }
});

myw.UserLocationPlugin.prototype.buttons = {
    locate: myw.PluginButton.extend({
        titleMsg: 'toolbar_msg',
        imgSrc: 'images/toolbar/locate.svg',
        id: 'userLocationButton',
        action() {
            this.app.recordFunctionalityAccess('core.toolbar.user_location');
            this.owner.locate();
            this.render();
        },

        render() {
            if (this.owner.tracking) {
                this.titleMsg = 'stop_tracking';
                this.imgSrc = 'images/toolbar/locate-active.svg';
            } else {
                this.titleMsg = 'toolbar_msg';
                this.imgSrc = 'images/toolbar/locate.svg';
            }
            this.setTitle(this.titleMsg);
            this.setImage(this.imgSrc);
        }
    })
};

export default myw.UserLocationPlugin;
